import React, { useState } from "react";
import { enviarReporteError } from "../api";
import { toast } from "react-hot-toast";

const opciones = [
  "Número incorrecto",
  "WhatsApp incorrecto",
  "Ubicación incorrecta",
  "Correo incorrecto",
  "Información desactualizada",
  "Otros"
];

const BottomSheetReporte = ({ comercio, sucursal, usuario, onClose, nombreComercio  }) => {
  const [seleccion, setSeleccion] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [exito, setExito] = useState(false);

  const handleEnviar = async () => {
    if (!usuario?.id) {
      toast.dismiss();
      toast.error("Necesitas acceder a tu cuenta para continuar.");
      return;
    }

    if (!seleccion) {
      toast.dismiss();
      toast.error("Selecciona al menos un motivo.");
      return;
    }

    if (mensaje.trim().length < 5) {
      toast.dismiss();
      toast.error("Describe el problema con al menos 5 caracteres.");
      return;
    }

    setEnviando(true);

    const res = await enviarReporteError({
      id_comercio: comercio,
      id_sucursal: sucursal,
      id_usuario: usuario.id,
      motivo: seleccion,
      mensaje
    });

    setEnviando(false);

    if (res.success) {
      setExito(true);
    } else {
      toast.dismiss();
      toast.error(res.error || "No se pudo enviar el reporte.");
    }
  };

  const cerrarExito = () => {
    setExito(false);
    onClose();
  };

  return (
    <>
      <div className="overlay-reporte" onClick={onClose}></div>
      <div className="bottom-sheet-reporte">
      {exito ? (
  <>
    <div className="overlay-reporte" onClick={cerrarExito}></div>
    <div className="bottom-sheet-exito">
        <svg className="check-pop" xmlns="http://www.w3.org/2000/svg" width="85" height="85" viewBox="0 0 50 50"><path fill="currentColor" d="M25 42c-9.4 0-17-7.6-17-17S15.6 8 25 8s17 7.6 17 17s-7.6 17-17 17m0-32c-8.3 0-15 6.7-15 15s6.7 15 15 15s15-6.7 15-15s-6.7-15-15-15"/><path fill="currentColor" d="m23 32.4l-8.7-8.7l1.4-1.4l7.3 7.3l11.3-11.3l1.4 1.4z"/></svg>
        <h3>¡Reporte enviado!</h3>
        <p>Gracias por ayudarnos a mejorar.</p>
        <button onClick={cerrarExito}>Ok</button>
    </div>
  </>
) : (
          <>
            <h3>¿Qué ocurre con {nombreComercio}?</h3>
            <div className="scroll-opciones-reporte">
              {opciones.map((op, i) => (
                <button
                  key={i}
                  className={`item-opcion-reporte ${seleccion === op ? "activo" : ""}`}
                  onClick={() => setSeleccion(op)}
                >
                  {op}
                </button>
              ))}
            </div>
            <textarea
              className="textarea-reporte"
              placeholder="Describe el problema (obligatorio)"
              value={mensaje}
              onChange={(e) => setMensaje(e.target.value)}
            />
            <button
              className="btn-enviar-reporte"
              onClick={handleEnviar}
              disabled={enviando}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 14 14">
                    <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="m5.812 11l2.178 2.168a1.1 1.1 0 0 0 1.05.3a1.12 1.12 0 0 0 .809-.74l3.576-10.72A1.118 1.118 0 0 0 11.987.57L1.267 4.147a1.12 1.12 0 0 0-.74.859a1.1 1.1 0 0 0 .3 1l2.737 2.737l-.09 3.466zM13.106.79L3.564 8.742" strokeWidth="1" />
                </svg>
              {enviando ? "Enviando..." : "Enviar"}
            </button>
          </>
        )}
      </div>
    </>
  );
};

export default BottomSheetReporte;
